/**
 * Query-key factory (PLAN §3 #6): every read model has one key; every mutation names the
 * keys it invalidates. Hierarchical so `invalidateQueries({ queryKey: keys.patient(id) })`
 * refreshes everything under a patient.
 */
export const keys = {
  session: ["session"] as const,
  /** The signed-in user's active sessions (/profile). */
  sessions: ["sessions"] as const,
  rail: ["rail"] as const,
  dashboard: (view: string) => ["dashboard", view] as const,
  analytics: ["analytics"] as const,
  patients: ["patients"] as const,
  patientSearch: (q: string) => ["patients", "search", q] as const,
  patient: (id: string) => ["patient", id] as const,
  workspace: (id: string) => ["patient", id, "workspace"] as const,
  schedule: (week: string, specialistId?: string) =>
    ["schedule", week, specialistId ?? "all"] as const,
  tasks: (filters: Record<string, unknown>) => ["tasks", filters] as const,
  pricing: ["pricing"] as const,
  invoices: (filters: Record<string, unknown>) => ["invoices", filters] as const,
  invoice: (id: string) => ["invoice", id] as const,
  gifts: (filters: Record<string, unknown>) => ["gifts", filters] as const,
  gift: (id: string) => ["gift", id] as const,
  /** /settings/notifications: the policy + availability + catalogue, previews, the log. */
  notificationSettings: ["notification-settings"] as const,
  notificationPreview: (kind: string, channel: string, theme: string) =>
    ["notification-preview", kind, channel, theme] as const,
  notificationDeliveries: ["notification-deliveries"] as const,
};
